/**
 * These filters are used by the API to fetch deals and it is also used
 * by our Deals tabs to filter the desired Deals from the state as within
 * the state all the deals are concatenated in an unique Array.
 */
export const FILTERS = Object.freeze({
  PAST: 'past',
  FUTURE: 'future',
});
